/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Penalizer, PenalizerInterface } from "../Penalizer";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_penalizeBlockDelay",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_penalizeBlockExpiration",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "commitHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "readyBlockNumber",
        type: "uint256",
      },
    ],
    name: "CommitAdded",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "commits",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "versionPenalizer",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getPenalizeBlockDelay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getPenalizeBlockExpiration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "rawTransaction",
        type: "bytes",
      },
    ],
    name: "isTransactionTypeValid",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "rawTransaction",
        type: "bytes",
      },
    ],
    name: "decodeTransaction",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gasLimit",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct IPenalizer.Transaction",
        name: "transaction",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "commitHash",
        type: "bytes32",
      },
    ],
    name: "commit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "unsignedTx1",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "signature1",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "unsignedTx2",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "signature2",
        type: "bytes",
      },
      {
        internalType: "contract IRelayHub",
        name: "hub",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "randomValue",
        type: "uint256",
      },
    ],
    name: "penalizeRepeatedNonce",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "unsignedTx",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "contract IRelayHub",
        name: "hub",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "randomValue",
        type: "uint256",
      },
    ],
    name: "penalizeIllegalTransaction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type PenalizerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PenalizerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Penalizer__factory extends ContractFactory {
  constructor(...args: PenalizerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _penalizeBlockDelay: BigNumberish,
    _penalizeBlockExpiration: BigNumberish,
    overrides?: Overrides & { from?: string }
  ): Promise<Penalizer> {
    return super.deploy(
      _penalizeBlockDelay,
      _penalizeBlockExpiration,
      overrides || {}
    ) as Promise<Penalizer>;
  }
  override getDeployTransaction(
    _penalizeBlockDelay: BigNumberish,
    _penalizeBlockExpiration: BigNumberish,
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _penalizeBlockDelay,
      _penalizeBlockExpiration,
      overrides || {}
    );
  }
  override attach(address: string): Penalizer {
    return super.attach(address) as Penalizer;
  }
  override connect(signer: Signer): Penalizer__factory {
    return super.connect(signer) as Penalizer__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PenalizerInterface {
    return new utils.Interface(_abi) as PenalizerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Penalizer {
    return new Contract(address, _abi, signerOrProvider) as Penalizer;
  }
}
